import { isEqual, unionWith } from 'lodash';
import { toSlug } from './utils';

const comparator = (a, b) => {
  if (a.id && b.id) {
    return (a.id === b.id);
  }

  return isEqual(a, b);
};

export const addItemsToDataLayer = (items, itemType) => {
  if (!window) {
    return;
  }

  let pastItems = [];
  let finalItems = [];
  const slugifiedType = toSlug(itemType);

  // Get current items (store them on client window)
  // Only useful for array of items, otherwise just replace it
  if (window[slugifiedType]) {
    pastItems = window[slugifiedType];
  }

  // Merge new items with old items while avoiding duplicates
  finalItems = unionWith(pastItems, items, comparator);

  // Only push to dataLayer if a new item has been added
  if (finalItems.length !== pastItems.length) {
    // Set new items to window
    const dataLayerObject = {};
    dataLayerObject[slugifiedType] = finalItems;
    dataLayerObject.event = `Add ${itemType} to dataLayer`;

    // Push to dataLayer and update window arrays
    window[slugifiedType] = finalItems;

    if (window.dataLayer) {
      window.dataLayer.push(dataLayerObject);
    }
  }
};

export const addObjToDataLayer = (obj, objKey) => {
  if (window) {
    const dataLayerObject = {};
    dataLayerObject[objKey] = obj;
    dataLayerObject.event = `Add ${objKey} to dataLayer`;

    if (window.dataLayer) {
      window.dataLayer.push(dataLayerObject);
    }
  }
};

export const addEventToDataLayer = (eventName, eventProps = {}) => {
  if (window) {
    const dataLayerObject = { ...eventProps };
    dataLayerObject.event = eventName;

    if (window.dataLayer) {
      window.dataLayer.push(dataLayerObject);
    }
  }
};

export const dataLayerIdGenerator = (itemType, slug) => {
  const lowerItemType = toSlug(itemType);
  return `${lowerItemType}_${toSlug(slug)}`;
};

export const dataLayerIdGeneratorNewItem = (itemType, item, dataLayerId) => {
  let newDataLayerId = dataLayerId;
  if (!dataLayerId) {
    const itemSlug = item && item.slug ? item.slug : '';
    newDataLayerId = dataLayerIdGenerator(itemType, itemSlug);
  }

  const newItem = { ...item };

  newItem.dataLayerId = newDataLayerId;
  return newItem;
};
